import React from 'react';
import './_styles/index.scss';
import numeral from 'numeral';
import { Link } from 'react-router-dom';
import { MdDone, MdClose } from 'react-icons/md';

export default ({ handle={}, count=0, total=0, hidden=true, cart=[], close }) => {

  if (!!hidden) {
    document.body.classList.remove('modal-open');
    return null;
  }

  const product = cart.filter(a => a.handle===handle)[0];

  const image = { backgroundImage: `url(${product.images[0]})` };

  const description =  ({ quantity=1 }) => {
    if (quantity===1)  return 'has been added to your shopping cart.'
    return `was already in your Cart. Quantity has been updated to ${quantity} pcs`;
  }

  const close_modal = () => {
    const modal = document.getElementById('cart-modal');
    if (!!modal) modal.classList.remove('modal-enter');
    if (!!modal) modal.classList.add('modal-leave');
    return close();
  }

  const cart_count = `${count} item${(count>1)?'s':''}`;

  document.body.classList.add('modal-open');

  return (
    <div className='add-to-cart-modal'>

      <div id='cart-modal' className="modal_wrapper modal-enter">

        <div className="heading">
          <div className="header-icon">
            <MdDone className='icon'/>
          </div>
          <div className="title">Added to Cart</div>
          <MdClose className='close-button' onClick={close_modal}/>
        </div>

        <div className="product-details">

          <div className="product-image" style={image}/>

          <div className="product-description">
            {`${product.title} ${description(product)}`}
          </div>

        </div>

        <div className="cart-summary">
          <span>{`Cart subtotal `}</span>
          <span>{`(${cart_count}): `}</span>
          <span>{`Ksh ${numeral(total).format('0,0.00')} `}</span>
        </div>

        <div className="button-wrapper">

          <div className="button button-close" onClick={close_modal}>
            Continue Shopping
          </div>

          <Link to='/cart' className="button button-checkout">
            {`Proceed to Checkout (${cart_count})`}
          </Link>

        </div>
      </div>

    </div>
  )
}
